import axios from "axios";
import { API } from "../axios/API";

export const convenioService = {
  getConvenios,
  getConvenio,
  getListConvenio,
  getConvCaracters,
  getConvFormaPagos,
  createConvenio,
  editConvenio,
  simPlanPago,
  comprobarConvenio,
  deleteConvenio,
  modRetiro,
  getConvenioById,
  simPlanPagoJson
};

async function getConvenios(data) {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/convFiltro.php", {
      data: {
        bsq: 1,
        ...data
      }
    });

    if (response.data?.mensaje) return response.data?.mensaje;

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function getConvenio(id) {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/dataConvenio.php", {
      data: {
        bsq: 1,
        id
      }
    });

    if (response.data?.mensaje) return response.data?.mensaje;

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function getListConvenio(data) {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaConv.php", {
      data: {
        bsq: 1,
        ...data
      }
    });

    if (response.data?.mensaje) return response.data?.mensaje;

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function createConvenio(data) {
  try {
    let response = await API.post("/convenios", data);

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function getConvenioById(id) {
  try {
    let response = await API.get(`/convenios/${id}`);

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function editConvenio(data) {
  try {
    let response = await API.post("/convenios/edit", data);

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function deleteConvenio(data) {
  try {
    let response = await API.post("/convenios/delete", data);

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err;
  }
}

async function getConvCaracters() {
  try {
    let response = await API.get("/conv-caracter");

    if (response.data?.length) {

      return response.data.map(e => {
        return {
          ...e,
          label: e.nombre,
          value: e.id
        };
      });
    }

    return response?.data;
  }
  catch (err) {
    return err;
  }
}

async function getConvFormaPagos() {
  try {
    let response = await API.get("/conv-formapago");

    if (response.data?.length) {

      return response.data.map(e => {
        return {
          ...e,
          label: e.nombre,
          value: e.id
        };
      });
    }

    return response?.data;
  }
  catch (err) {
    return err;
  }
}

async function simPlanPago(data) {
  try {
    // PARÁMETROS:
    // rec: recurso de cuenta
    // imp: número de cuenta
    // cuotas: cuotas del plan de pago a calcular
    // monto: valor de la deuda a simular con descuento de intereses
    // plan: tipo de plan, valor por defecto ABLT
    // anticipo: monto de cuota anticipo

    // W2113 - 6 CUOTAS SIN INTERES
    // W2112 - 3 CUOTAS SIN INTERES
    // W2201 - 1 CUOTA C/QUITA 45% DE INTERESES
    // W2203 - ANTICIPO Y 6 CUOTAS
    // ABLT - default
    let response = await API.post("/convenios/simPlanPago", data);

    return response.data;
  }
  catch (err) {
    console.log(err);
    return err;
  }
}

async function comprobarConvenio(data) {
  try {
    let response = await API.post("/convenios/comprobar", data);

    return response.data;
  }
  catch (err) {
    console.log(err);
    return err;
  }
}

async function modRetiro(data) {
  try {
    let response = await API.put("/convenios", data);

    return response.data;
  }
  catch (err) {
    console.log(err);
    return err;
  }
}

async function simPlanPagoJson(data) {
  try {
    // PARÁMETROS:
    // rec: recurso de cuenta
    // imp: número de cuenta
    // cuotas: cuotas del plan de pago a calcular
    // monto: valor de la deuda a simular con descuento de intereses
    // plan: tipo de plan, valor por defecto ABLT
    // anticipo: monto de cuota anticipo

    // W2113 - 6 CUOTAS SIN INTERES
    // W2112 - 3 CUOTAS SIN INTERES
    // W2201 - 1 CUOTA C/QUITA 45% DE INTERESES
    // W2203 - ANTICIPO Y 6 CUOTAS
    // ABLT - default
    let response = await API.post("/convenios/simPlanPagoJson", data);

    return response.data;
  }
  catch (err) {
    console.log(err);
    return err;
  }
}